import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { UserAvatar } from './UserAvatar';
import { AvatarUploadButton } from './AvatarUploadButton';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const ROLE_LABELS = { ADMIN: 'Administrateur', PRINCIPAL: 'Directeur', TEACHER: 'Professeur', STUDENT: 'Élève', PARENT: 'Parent', TREASURER: 'Trésorier', SECRETARY: 'Secrétaire', ACCOUNTANT: 'Comptable' };

export default function ProfilePhotosPage() {
  const [users, setUsers] = useState([]);
  const [q, setQ] = useState('');
  useEffect(() => {
    axios.get(`${API}/users`).then((r) => setUsers(r.data)).catch(() => {});
  }, []);
  const term = q.toLowerCase();
  const shown = users.filter((u) => `${u.first_name} ${u.last_name} ${u.email}`.toLowerCase().includes(term)).slice(0, 100);
  const setPhoto = (id, url) => setUsers((prev) => prev.map((u) => (u.id === id ? { ...u, avatar_url: url } : u)));

  return (
    <div className="p-6 space-y-4" data-testid="profile-photos-page">
      <Card>
        <CardHeader>
          <CardTitle>Photos de profil</CardTitle>
          <CardDescription>Ajoutez, remplacez ou retirez la photo d’un élève ou d’un membre de l’établissement (PNG, JPG ou WEBP, 3 Mo maximum).</CardDescription>
        </CardHeader>
        <CardContent className="space-y-3">
          <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Rechercher par nom ou email" className="max-w-md" data-testid="photos-search-input" />
          <div className="divide-y border rounded-md">
            {shown.map((u) => (
              <div key={u.id} className="flex items-center justify-between px-3 py-2" data-testid={`photo-row-${u.id}`}>
                <div className="flex items-center gap-3">
                  <UserAvatar person={u} size="md" testId={`user-avatar-${u.id}`} />
                  <div>
                    <p className="font-medium text-sm">{u.first_name} {u.last_name}</p>
                    <p className="text-xs text-gray-500">{ROLE_LABELS[u.role] || u.role} · {u.email}</p>
                  </div>
                </div>
                <AvatarUploadButton compact userId={u.id} hasPhoto={!!u.avatar_url} onChange={(url) => setPhoto(u.id, url)} />
              </div>
            ))}
          </div>
          {users.length > shown.length && <p className="text-xs text-gray-500">Affinez la recherche pour voir plus de résultats.</p>}
        </CardContent>
      </Card>
    </div>
  );
}
